import React from 'react';
import { useParams } from 'react-router-dom';
import Footer from '../Footer';
import Header from '../Header';
import TitleBanner from '../titlebanner';
import Work from '../Home/work';
import Mission from '../Home/mission';
import ProjectDetail from './projectdetails';

const ProjectDetailPage = () => {
    // We only need the ID to verify it exists in the URL
    const { projectId } = useParams(); 

    // We REMOVE the PROJECT_LIST.find because the data is now in the Cloud (Firebase)
    // The <ProjectDetail /> component inside will use the ID to fetch the data.

    return (
        <>
            <Header />
            {/* You can pass a generic title or leave it to the banner */}
            <TitleBanner title={"Project Portfolio"} />
            
            {/* This component now does the heavy lifting of fetching from Firebase */}
            <ProjectDetail />
            
            <Work />
            <Mission />
            <Footer />
        </>
    );
};

export default ProjectDetailPage;